import Layout from "../../components/Layout";
import { DataKeluhan } from "../../data/DataKeluhan";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { keluhanBreadcrumb, defBreadcrumb } from "../../data/DataBreadcrumb";
import NextHead from "../../components/Seo/NextHead";
import { keluhanMeta } from "../../data/DataMetatags";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import Description from "../../components/UserInterface/Description";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import { DownloadLink } from "../../components/UserInterface/DownloadLink";
import ComplaintProcedure from "../../../public/static/images/png/complaint/complaint-web.png";
import ComplaintChannel from "../../../public/static/images/png/complaint/complaint-channel.png";
import ComplaintMediation from "../../../public/static/images/png/complaint/complaint-mediation.png";
import PdfIcon from "../../../public/static/images/png/pdf-icon.png";
import MailIcon from "../../../public/static/images/png/mail-icon.png";
import TelIcon from "../../../public/static/images/png/telephone-icon.png";

const Keluhan = (props) => {
  const { breadcrumb, title, description, path } = props;
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={keluhanBreadcrumb}></BreadcrumbComponent>
      <HeadingComponent fontWeight="bold" headingText="Penanganan Keluhan"></HeadingComponent>
      <LayoutCenter margin="0">
        <Description
          align="left"
          font="Roboto"
          text="Home Credit berkomitmen untuk menyediakan layanan yang transparan dan memastikan bahwa setiap laporan akan mendapatkan penanganan dan penyelesaian pengaduan tanpa dikenai biaya tambahan apa pun."
        ></Description>
      </LayoutCenter>
      <HeadingComponent justifyLeft margin="20px" marginHeadingMobile="30px 0 10px 10px" fontSize="18px" fontWeight="bold" headingText="Prosedur Pengaduan Keluhan Pelanggan"></HeadingComponent>
      <img style={{ width: "90%", maxWidth: "700px", height: "auto", margin: "auto" }} src={ComplaintProcedure} />
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <p>Lihat panduan lengkap di <a className="text-link" target="_blank" href="/static/pdf/Panduan-Singkat-Penanganan-Pengaduan-Konsumen.pdf"> sini</a> </p>
      </div>
      <HeadingComponent justifyLeft margin="65px 0 0 0" marginHeadingMobile="30px 0 0 10px" fontSize="18px" fontWeight="bold" headingText="Informasi Penting"></HeadingComponent>
      <LayoutCenter margin="0" justifyDesktop="start">
        <Description
          align="left"
          font="Roboto"
          text="Jika keberatan atau menolak penyelesaian yang diberikan, Pelanggan atau Pelapor juga dapat menyampaikan pengaduan melalui:"
        ></Description>
      </LayoutCenter>
      <LayoutCenter column>
        <div className="information-container">
          <img src={ComplaintChannel} />
          <Description
            align="left"
            font="Roboto"
            text={DataKeluhan.channel}
          ></Description>
        </div>
        <div className="information-container">
          <img src={ComplaintMediation} />
          <Description
            align="left"
            font="Roboto"
            text={DataKeluhan.mediation}
          ></Description>
        </div>
        <HeadingComponent margin="50px 0 15px 0" fontSize="18px" fontWeight="bold" headingText="Hubungi Kami"></HeadingComponent>
        <LayoutCenter margin="0 0 30px 0">
          <div className="complaint-contact">
            <img src={MailIcon} />
            <div>
              <p>care@homecredit.co.id</p>
              <p>24 Jam</p>
            </div>
          </div>
          <div className="complaint-contact">
            <img src={TelIcon} />
            <div>
              <p>021 2953 9600</p>
              <p>Setiap hari, 07.00 – 20.00 WIB</p>
            </div>
          </div>
        </LayoutCenter>
        <HeadingComponent margin="30px" fontSize="18px" fontWeight="bold" headingText="Publikasi Penanganan Pengaduan"></HeadingComponent>
        <DownloadLink
          withContainer
          img={PdfIcon}
          linkName="Publikasi Penanganan Pengaduan 2019 - 2023"
          url="/static/pdf/publikasi-penanganan-pengaduan-2023.pdf"
        />
        <br />
      </LayoutCenter>
      <style jsx>{`
        .container-link {
          grid-column-gap: 10px;
          display: grid;
          grid-template-rows: 1fr 1fr 1fr;
          grid-auto-flow: column;
        }
        .information-container {
          width: 75%;
          display: flex;
          align-items: center;
        }
        .information-container img{
          width: 180px;
          height: auto;
          margin: 20px 50px;
        }
        .complaint-contact {
          width: 300px;
          display: flex; 
          flex-direction: column;
          align-items: center;
          margin: 0px 30px;
        }
        .complaint-contact img{
          border: 1px dashed grey;
          width: 65px;
          height: auto;
          margin: 10px;
        }
        .complaint-contact p{
          text-align: center;
          margin: 0px;
        }
        .text-link {
          color: var(--color-red);
          text-decoration: underline;
          font-weight: bold;
        }
        @media only screen and (max-width: 630px) {
          .container-link {
            display: inline;
          }
          .information-container {
            width: 100%;
            flex-direction: column-reverse;
          }
          .information-container img{
            width: 200px;
            margin: 10px 50px;
          }
          .complaint-contact {
            width: 100%;
            flex-direction: row;
          }
          .complaint-contact p{
            text-align: left;
            font-size: 14px;
          }
        }
      `}</style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = keluhanMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + path,
        name: title
      }
    }
  ];
  return { props: { breadcrumb, title, description, path } };
};

export default Keluhan;
